import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'cast',
	pure: true,
	standalone: true,
})
export class TemplateCastPipe implements PipeTransform {
	transform<T>(value): T {
		return value as T;
	}
}

@Pipe({
	name: 'anyCast',
	pure: true,
	standalone: true,
})
export class AnyTemplateCastPipe<T> implements PipeTransform {
	transform(value): T {
		return value as T;
	}
}
